import { toQuery } from 'src/utils/utils';

import { handleResponse } from '../utils/auth-header';
import axios, { axiosOption } from '../utils/axios';

export const NewdanhmucphieuxuatService = {

  checkSoKhungSoMay: (payload) => {
		return axios.post(`/api/v1/newdanhmucphieuxuat/checkSoKhungSoMay`, payload, axiosOption()).then((rs) => {
			return handleResponse(rs)
		}).catch((error) => {
			throw handleResponse(error.response)
		})
	},

	homepageFindOne: (id) => {
		return axios.get(`/api/v1/newdanhmucphieuxuat/homepageFindOne/${id}`, axiosOption()).then((rs) => {
			return handleResponse(rs)
		}).catch((error) => {
			throw handleResponse(error.response)
		})
	},
	
	sendOrder: (payload) => {
		return axios.post('/api/v1/newdanhmucphieuxuat/sendOrder', payload, axiosOption()).then((rs) => {
			return handleResponse(rs)
		}).catch((error) => {
			throw handleResponse(error.response)
		})
	},
	
	create: (payload) => {
    return axios.post('/api/v1/newdanhmucphieuxuat', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  save: (payload) => {
    return axios.post('/api/v1/newdanhmucphieuxuat/import', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  update: (id, payload) => {
    return axios.put(`/api/v1/newdanhmucphieuxuat/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  findAll: (page, count, payload) => {
    let url = `/api/v1/newdanhmucphieuxuat?page=${page}&count=${count}`;

    if (payload.so) {
      url += `&so=${payload.so}`
    };
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  listExport: (payload) => {
    let url = `/api/v1/newdanhmucphieuxuat?page=${payload.page}&count=${payload.limit}`;

    if (payload.so) {
      url += `&so=${payload.so}`
    };
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findAssign: (page, count) => {
    return axios.get(`/api/v1/newdanhmucphieuxuat/assign?page=${page}&count=${count}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  find: (id) => {
    return axios.get(`/api/v1/newdanhmucphieuxuat/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findPackage: (ten_goi_cuoc) => {
    return axios.get(`/api/v1/newdanhmucphieuxuat/findPackage/${ten_goi_cuoc}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  countAssign: () => {
    return axios.get(`/api/v1/newdanhmucphieuxuat/count-assign`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  delete: (id) => {
    return axios.delete(`/api/v1/newdanhmucphieuxuat/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  assign: (payload) => {
    return axios.post(`/api/v1/newdanhmucphieuxuat/assign`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  history: (payload) => {
    return axios.get(`/api/v1/care/history?${toQuery(payload)}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  listNoLimit: () => {
    return axios.get(`/api/v1/newdanhmucphieuxuat/listNoLimit`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  getSimAnalysis: (number) => {
    return axios.get(`/api/v1/newdanhmucphieuxuat/getSimAnalysis/${number}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },
}